import { fill } from 'lodash';
import { FloatLabel } from 'primereact/floatlabel';
import { InputMask } from 'primereact/inputmask';
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Container, FloatingLabel, Form, Overlay, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { Checkbox, Column, Icon, Panel, Select } from "../../components";
import { AbilityContext } from "../../shared/abilities/AbilityContext";
import AppContext from "../../shared/components/AppContext";
import { SelectOption } from "../../shared/components/input";
import TextInputWithZipCode from '../../shared/components/input/TextInputWithZipCode';
import { useConfirmationModalContext } from "../../shared/components/ModalConfirmationContext";
import Logger from "../../shared/services/Logger";
import { RootState } from "../../shared/store";
import * as constant from '../../shared/util/constant';
import * as label from '../../shared/util/label';
import { CustomerScreentLables as cstScrLables } from "../../shared/util/label";
import { uuid } from "../../shared/util/uuid";
import { updateLookupData } from "../customer-slice/Customer-lookup-slice";
import { updateCustomers } from "../customer-slice/Customer-slice";
import { cleareTabsInputs } from "../customer-slider-content/CustomerSliderContext";
import Customer from "../model/Customer";
import { CustomerCompanyContact } from "../model/CustomerCompanyContactModel";
import { CustomerDependent } from "../model/CustomerDependentModel";
import CustomerCompanyContactView from "./CustomerCompanyContactView";
import CustomerDependentView from "./CustomerDependentView";
import './CustomerDetail.scss';
import CustomerDetailService from "./CustomerDetailService";
import { CommonUtility } from '../../Services/CommonUtility';





export interface ICustomerDetailComponent {
    customerId: string,
    isCreatingNewCustomer: boolean
}

const CustomerDetail: React.FunctionComponent<ICustomerDetailComponent> = (props) => {
    //const [tabIndex, setIndexCounter] = useState<number>(0);
    let tabIndexCounter = 1;
    const history = useHistory();
    const customerDetailService = new CustomerDetailService();
    const id = props.customerId;
    const isCreatingNewCustomer = props.isCreatingNewCustomer;
    const currentURL = useLocation().pathname;
    //const [inputZipValue, setInputZipValue] = useState("");
    // Customer details to show.
    const [customerDetail, setCustomerDetail] = useState<Customer>({});
    const [intialCustomerDetail, setInitialCustomerDetail] = useState<Customer>({});
    const [showTooltip, setShowTooltip] = useState(false);
    const [showCopyTooltip, setShowCopyTooltip] = useState(false);
    const [copyOverlayTarget, setCopyOverlayTarget] = useState<HTMLElement | null>(null);
    const [counter, setCounter] = useState(0);
    const [control, setControl] = useState('');
    // Lookup data states.
    const [maritalStatuses, setMaritalStatuses] = useState<SelectOption[]>([]);
    const [industries, setIndustries] = useState<SelectOption[]>([]);
    const [occupancies, setOccupancies] = useState<SelectOption[]>([]);
    const [relationships, setRelationShips] = useState<SelectOption[]>([]);
    const [agencies, setAgencies] = useState<SelectOption[]>([]);
    const [genders, setGenderList] = useState<SelectOption[]>([]);
    const [states, setStates] = useState<SelectOption[]>([]);
    const [countries, setCountries] = useState<SelectOption[]>([]);
    const [statesUS, setUSState] = useState<SelectOption[]>([]);
    const [statesCanada, setCanadaState] = useState<SelectOption[]>([]);
    const [individualizedList, setIndividualizedList] = useState<SelectOption[]>([]);
    const [isStateAsDropdown, setIsstateAsDropdown] = useState(false);
    const [formValidation, setFormValidation] = useState<any>({});
    const [isExpended, setIsExpended] = useState(false);
    const [isEditable, setIsEditable] = useState(false);
    const [reset, isReset] = useState(false);
    const [isFormSaved, setFormSaved] = useState(true);
    const [isBillingInfoVisible, setIsBillingInfoVisible] = useState(customerDetail?.isBillAddressSame);
    const modalContext = useConfirmationModalContext();
    const myContext = useContext(AppContext);
    const divToScroll = useRef(null)
    const firstNameRef = useRef(null)
    const addContactButtonRef = useRef(null);
    const userDetails = useSelector((state: any) => state.userContextSlice);
    const [isStateRequired, setIsStateRequired] = useState(false);
    const [isCountryChanged, setIsCountryChanged] = useState(false);


    const ab_subject = "Customer";
    const ability = useContext(AbilityContext);
    const canUserEditCustomer = ability.can('update', ab_subject, constant.ScreenName.CUSTOMER);
    const canUserDeleteCustomer = ability.can('delete', ab_subject, constant.ScreenName.CUSTOMER);
    const canUserCreateCustomer = ability.can('create', ab_subject, constant.ScreenName.CUSTOMER);
    const isUserPermitToUpdateVip = ability.can('read', ab_subject, constant.ScreenName.CUSTOMER_VIP);
    const [pendingFocusDependentId, setPendingFocusDependentId] = useState<string | null>(null);
    /// Get customer and lookup from redux slicer.
    const dispatch = useDispatch()
    let customerInfo = useSelector((state: RootState) => state?.customerSlice);
    let maritalStatusLookUp = useSelector((state: RootState) => state?.LookupState.maritalStatusList);
    let industryLookup = useSelector((state: RootState) => state?.LookupState.industryList);
    let occupationLookup = useSelector((state: RootState) => state?.LookupState.occupancyList);
    let relatioshipLookup = useSelector((state: RootState) => state?.LookupState.relationshipList);
    let agencyLookup = useSelector((state: RootState) => state?.LookupState.agencyList);
    let stateLookup = useSelector((state: RootState) => state?.LookupState.stateList);
    let countryLookup = useSelector((state: RootState) => state?.LookupState.countryList);
    let stateUSLookup = useSelector((state: RootState) => state?.LookupState.stateUSList);
    let stateCanadaLookup = useSelector((state: RootState) => state?.LookupState.stateCanadaList);
    let genderLoopUp = useSelector((state: RootState) => state.LookupState.genderList);
    let individualizedLookup = useSelector((state: RootState) => state.LookupState.individualizedList);

    useEffect(() => {

        if (currentURL === '/customer-new' && !canUserCreateCustomer) {
            history.push('/unauthorized-access');
        }

    }, [currentURL]);


    useEffect(() => {
        if(customerDetail.countryId == constant.DATA_IDs.COUNTRIES.USA){
            setIsStateRequired(true);
        }
    }, [customerDetail.countryId]);

    useEffect(() => {
        if (!isCreatingNewCustomer && customerInfo.customer.id === id && (customerInfo.customer.id !== null && customerInfo.customer.id !== undefined)) {
            setCustomerDetail(customerInfo.customer)
        }
    }, [customerInfo]);

    useEffect(() => {
        initializeComponent(id);
    }, [id]);
    useEffect(() => {
        myContext.formSavedStatus = isFormSaved
    }, [isFormSaved])

    /// Method to intialize component.
    let initializeComponent = async (customerId: string) => {
        try {
            /// Check if customer object available in redux slicer, if not fetch it from service.
            let customerData = getNewCustomer();
            if (!isCreatingNewCustomer) {
                customerData = customerInfo.customer;
                if (customerInfo.customer.id !== id || customerInfo.customer.id === null || customerInfo.customer.id === undefined) {
                    customerData = await customerDetailService.fetchCustomerById(customerId);
                    dispatch(updateCustomers(customerData))
                }
            }
            else {
                customerData.countryId = constant.DATA_IDs.COUNTRIES.USA;
                EditCustomer();
            }

            let initData = {
                maritalStatusList: [], industryList: [], occupancyList: [], relationshipList: [],
                agencyList: [], stateList: [], countryList: [], stateUSList: [], stateCanadaList: [], genderList: [],
                individualizedList: []
            };
            if (maritalStatusLookUp.length === 0 ||
                industryLookup.length === 0 || occupationLookup.length === 0 ||
                relatioshipLookup.length === 0 || agencyLookup.length == 0 || stateLookup.length === 0 ||
                countryLookup.length === 0 || stateUSLookup.length === 0 || stateCanadaLookup.length === 0) {
                initData = await customerDetailService.fetchComponentInitData(userDetails?.userContext?.agencyGroupId);
                dispatchAllLookup(initData)
            }
            else {
                initData = {
                    maritalStatusList: [...maritalStatusLookUp], industryList: [...industryLookup],
                    occupancyList: [...occupationLookup], relationshipList: [...relatioshipLookup],
                    agencyList: [...agencyLookup], stateList: [...stateLookup], countryList: [...countryLookup],
                    stateUSList: [...stateUSLookup], stateCanadaList: [...stateCanadaLookup], genderList: [...genderLoopUp],
                    individualizedList: [...individualizedLookup]
                };
            }

            setMaritalStatuses(initData.maritalStatusList);
            setIndustries(initData.industryList);
            setOccupancies(initData.occupancyList)
            setRelationShips(initData.relationshipList);
            setAgencies(initData.agencyList);
            setGenderList(initData.genderList);
            setCountries(initData.countryList)
            setUSState(initData.stateUSList)
            setCanadaState(initData.stateCanadaList)
            setCustomerDetail(customerData);
            setInitialCustomerDetail(customerData)
            setIsstateAsDropdown(customerData.countryId ? customerData.countryId === constant.DATA_IDs.COUNTRIES.CANADA || customerData.countryId === constant.DATA_IDs.COUNTRIES.USA : true)
            setStates(customerData.countryId ? customerData.countryId === constant.DATA_IDs.COUNTRIES.USA ? initData.stateUSList :
                customerData.countryId === constant.DATA_IDs.COUNTRIES.CANADA ? initData.stateCanadaList :
                    [] : initData.stateUSList)
            setIndividualizedList(initData.individualizedList);
            firstNameRef.current?.focus();
        }
        catch (ex) {
            toast.error(constant.CUSTOMER_DETAIL_ERROR_WHILE_LOADING_INITIAL_DATA, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const getNewCustomer = (): Customer => {
        return {
            customerDependents: [],
            customerContacts: [],
        };
    }

    const onEntityFieldChange = (propName: string, value: string | Date | boolean) => {
        setCustomerDetail({
            ...customerDetail,
            [propName]: value,
        });

        if (propName == 'firstName' || propName == 'lastName') {
            setCustomerDetail(cst => {
                return {
                    ...cst,
                    displayName: (cst.firstName ? cst.firstName : '') + ' ' + (cst.lastName ? cst.lastName : ''),
                };
            });
        }

        if (propName.toLocaleLowerCase() == 'zipcode' || propName.toLocaleLowerCase() == 'billzip') {
            let val = zipCodeFormat(value);
            setCustomerDetail({
                ...customerDetail,
                [propName]: val,
            });
        }

        
        if (propName == 'state') {
           setFormValidation((prev: any) => ({
                ...prev,
                state: { isValid: true, warningText: null }
            }));
        }
        if (propName == 'billState' && !customerDetail.isBillAddressSame) {
            setFormValidation((prev: any) => ({
                ...prev,
                billState: { isValid: true, warningText: null }
            }));
        }

    }

    const zipCodeFormat = (value: string): any => {
        if(isStateRequired){
        let val = value.toString().replace(/[^0-9-]/g, ''); // Remove non-digit and non-hyphen characters
        val = val.replace(/-/g, ''); // Remove existing hyphens

        if (value.toString().length > 5) {
            val = val.slice(0, 5) + '-' + val.slice(5); // Add hyphen after 5 characters
        }
        return val.slice(0, 10); // Limit to 10 characters including hyphen
        }
        else{
           let val= value.toString().replace(/[^A-Za-z0-9\- ]/g, '');
           return val;
        }
    }

    const toggleEntityField = (propName: string) => {
        let newValue = !customerDetail[propName];
        let updates: any = {
            [propName]: newValue,
        };
        
        // If SMS Opt Out is being checked, uncheck all phone SMS opt-ins
        if (propName === 'smsOptOut' && newValue === true) {
            updates.workPhoneSmsOptIn = false;
            updates.mobileSmsOptIn = false;
            updates.otherPhone1SmsOptIn = false;
            updates.otherPhone2SmsOptIn = false;
            updates.otherPhone3SmsOptIn = false;
        }
        
        setCustomerDetail({
            ...customerDetail,
            ...updates,
        });
    }
    const populateBillingAddress = (event) => {
        if (event.currentTarget.checked) {
            setCustomerDetail({
                ...customerDetail,
                isBillAddressSame: !customerDetail.isBillAddressSame,
                billAddress1: customerDetail.address1,
                billAddress2: customerDetail.address2,
                billCity: customerDetail.city,
                billState: customerDetail.state,
                billZip: customerDetail.zipCode,

            })
        }
        else {
            setCustomerDetail({
                ...customerDetail,
                isBillAddressSame: !customerDetail.isBillAddressSame,
                billAddress1: "",
                billAddress2: "",
                billCity: "",
                billState: "",
                billZip: "",
            })
        }
    }

    
    const onCountrySelection = (countrySelected: string) => {
        setIsStateRequired(false);
        setIsCountryChanged(true);

        setCustomerDetail({
            ...customerDetail,
            countryId: countrySelected,
            state: "",
            billState: "",
            zipCode: "",
            billZip: "",
        })
        let validationError = customerDetailService.validateCustomer(customerDetail);
        if (countrySelected == constant.DATA_IDs.COUNTRIES.USA) {
            setIsstateAsDropdown(true)
            setStates(statesUS);
            setIsStateRequired(true);
            setFormValidation(validationError);
        }
        else if (countrySelected == constant.DATA_IDs.COUNTRIES.CANADA) {
            setIsstateAsDropdown(true)
            setStates(statesCanada)
            setFormValidation((prev: any) => ({
                ...prev,
                state: { isValid: true, warningText: null },
                billState: { isValid: true, warningText: null }
            }));
        }
        else {
            setIsstateAsDropdown(false)
            setStates([]);
            setFormValidation((prev: any) => ({
                ...prev,
                state: { isValid: true, warningText: null },
                billState: { isValid: true, warningText: null }

            }));
        }

    }

    // Update a collection property value. For example any of the dependent information changed in child component. 
    // param : collectionPropName                   -- Name of the navigation collection property. Example for customer.customerDependents, it's 'customerDependents'
    // param : collectionEntityIdentifierPropName   -- Name of the navigation collection property identifier. Example for customer.customerDependents, it's 'deptId'
    // param : collectionEntityIdentifierValue      -- Identifier for naviation collection prop. here it depdId value.
    // param : propName                             -- Name of navigation entity prop, which is changed. like 'firstName', 'lastName', 'relationshipId' etc.
    // param : value                                -- value changed.
    const onCollectionEntityFieldChange = (collectionPropName: string, collectionEntityIdentifierPropName: string, collectionEntityIdentifierValue: any, propName: string, value: string | Date | boolean) => {
        let subCollectionEntityIndex = customerDetail[collectionPropName].findIndex(item => item[collectionEntityIdentifierPropName] == collectionEntityIdentifierValue);
        
        let updatedSubEntity;

          if(propName == "country"){
            updatedSubEntity = {
                ...customerDetail[collectionPropName][subCollectionEntityIndex],
                "city":null,
                "state":null,
                "zip":null,
                "countryId":value,
                isModified: true
            };
        }else 
             if(propName == "state"){
            updatedSubEntity = {
                ...customerDetail[collectionPropName][subCollectionEntityIndex],
                "city":null,
                "zip":null,
                "state":value,
                isModified: true
            };
        }
        else{
            updatedSubEntity = {
            ...customerDetail[collectionPropName][subCollectionEntityIndex],
            [propName]: value,
            isModified: true
        };
        }

        let collectionCopy = [...customerDetail[collectionPropName]];
        collectionCopy.splice(subCollectionEntityIndex, 1, updatedSubEntity);

        setCustomerDetail(cst => {
            var updatedObj = {
                ...cst,
                [collectionPropName]: collectionCopy
            };
            return updatedObj;
        });
    }

    const resetVal = (collectionPropName: string, collectionEntityIdentifierPropName: string, collectionEntityIdentifierValue: any, propName: string, value: string | Date | boolean | Object) => {
        let subCollectionEntityIndex = customerDetail[collectionPropName].findIndex(item => item[collectionEntityIdentifierPropName] == collectionEntityIdentifierValue);
        let updatedSubEntity;
        if(propName == "country"){
            updatedSubEntity = {
                ...customerDetail[collectionPropName][subCollectionEntityIndex],
                "city":null,
                "state":null,
                "zip":null,
                "countryId":value,
                isModified: true
            };
        }else 
             if(propName == "state"){
            updatedSubEntity = {
                ...customerDetail[collectionPropName][subCollectionEntityIndex],
                "city":null,
                "zip":null,
                "state":value,
                isModified: true
            };
        }
        else{
            updatedSubEntity = {
                ...customerDetail[collectionPropName][subCollectionEntityIndex],
                [propName]: value,
                isModified: true
            };
        }

        let collectionCopy = [...customerDetail[collectionPropName]];
        collectionCopy.splice(subCollectionEntityIndex, 1, updatedSubEntity);

        setCustomerDetail(cst => {
            var updatedObj = {
                ...cst,
                [collectionPropName]: collectionCopy
            };
            return updatedObj;
        });
    }
    
    const scrollToNewSection = () => {
        divToScroll.current && divToScroll.current.scrollIntoView({ behavior: 'smooth' })
    }
    const onAddCompanyContactClick = (e) => {
        let panelHtml = e.currentTarget.closest('div') as HTMLDivElement
        panelHtml.click();
        setCustomerDetail(cust => {
            let custData = { ...cust };
            custData.customerContacts = [...custData.customerContacts || [], { id: uuid() }];
            return custData;
        });
        
        if (customerDetail.customerContacts.length == 1) {
            setCounter(200);
        }

        setTimeout(() => {
            scrollToNewSection();
        }, 500)
        e.stopPropagation()
    }

    const onAddDependentClick = (e) => {
    let panelHtml = e.currentTarget.closest('div') as HTMLDivElement;
    panelHtml.click();

    const newDepdId = uuid();
    setPendingFocusDependentId(newDepdId);

    setCustomerDetail(cust => {
        let custData = { ...cust };
        custData.customerDependents = [...custData.customerDependents || [], { depdId: newDepdId }];
        return custData;
    });

    setTimeout(() => {
        scrollToNewSection();
    }, 500);

    e.stopPropagation();
}
    const onDependentDelete = (dependentToDelete: CustomerDependent) => {
        setCustomerDetail(cust => {
            let custData = { ...cust };
            custData.customerDependents = custData.customerDependents.filter(item => item.depdId != dependentToDelete.depdId);
            return custData;
        });
        setCounter(counter - 13)
    }

    const handleTabIndex = (newValue) => {
        setCounter(newValue);
        tabIndexCounter = newValue;
    };


    const onDeleteContact = (contactToDelete: CustomerCompanyContact) => {
        setCustomerDetail(cust => {
            let custData = { ...cust };
            custData.customerContacts = custData.customerContacts.filter(item => item.id != contactToDelete.id);
            return custData;
        });
    }

    const customerDependentsPanelHeaderItems = <><Button id={"btnAddDependent"} tabIndex={25} disabled={!isEditable} size="sm" variant="outlined"
        onClick={(e) => { onAddDependentClick(e); }}>{cstScrLables.ADD_ADDITIONAL_CUSTOMER_BUTTON}</Button>
    </>;
    const customerCompanyContsctsPanelHeaderItems = <><Button id={"btnAddCntact"} ref={addContactButtonRef} tabIndex={200} disabled={!isEditable} size="sm" variant="outlined" onClick={(e) => { onAddCompanyContactClick(e); }}>{cstScrLables.ADD_COMPANY_CONTACT}</Button></>;

    const customerDependentView = customerDetail.customerDependents?.length ? (
        
        (() => {
            const dependentViews: JSX.Element[] = [];
            customerDetail.customerDependents?.forEach((cd, index) => {
                dependentViews.push(
                    <CustomerDependentView
                        key={cd.depdId}
                        index={index}
                        dependent={cd}
                        maritalStatuses={maritalStatuses}
                        industries={industries}
                        occupancies={occupancies}
                        onFieldChange={onCollectionEntityFieldChange}
                        onDelete={onDependentDelete}
                        formValidations={formValidation['customerDependents'] ? formValidation['customerDependents'][cd.depdId] : {}}
                        relationships={relationships}
                        isEditable={isEditable}
                        isReset={reset}
                        divToScroll={divToScroll}
                        counter={counter}
                        updateCounter={handleTabIndex}
                        pendingFocusDependentId={pendingFocusDependentId}
                        onDependentFocusHandled={() => setPendingFocusDependentId(null)}
                    />
                );
            });
            return dependentViews.length ? dependentViews : (
                <div className="alert alert-light text-muted text-center p-3">No additional customers found</div>
            );
        })()
    ) : (
        <div className="alert alert-light text-muted text-center p-3">No additional customers found</div>
    );

    const customerContactView = customerDetail.customerContacts?.length ? (
        customerDetail.customerContacts.map((ct, index) => (
            <CustomerCompanyContactView
                index={index}
                key={ct.id}
                contact={ct}
                statesUS={states}
                countries={countries}
                onFieldChange={onCollectionEntityFieldChange}
                onDelete={onDeleteContact}
                formValidations={formValidation['customerContacts'] ? formValidation['customerContacts'][ct.id] : {}}
                isEditable={isEditable}
                isReset={reset}
                divToScroll={divToScroll}
                counter={counter}
                updateCounter={handleTabIndex}
                statesCanada={statesCanada}
                resetVal={resetVal}
            />
        ))
    ) : (
        <div className="alert alert-light text-muted text-center p-3">No company contacts found</div>
    );


    const contactInoLg = 4;
    const contactInoMd = 4;

    const dispatchAllLookup = (initData) => {
        dispatch(updateLookupData({ data: initData.maritalStatusList, type: constant.SlicerLookUpConstant.MARITAL_STATUS }));
        dispatch(updateLookupData({ data: initData.industryList, type: constant.SlicerLookUpConstant.INDUSTRY }));
        dispatch(updateLookupData({ data: initData.occupancyList, type: constant.SlicerLookUpConstant.OCCUPATION }));
        dispatch(updateLookupData({ data: initData.agencyList, type: constant.SlicerLookUpConstant.AGENCY }));
        dispatch(updateLookupData({ data: initData.relationshipList, type: constant.SlicerLookUpConstant.RELATIONSHIP }));
        dispatch(updateLookupData({ data: initData.stateList, type: constant.SlicerLookUpConstant.STATE }));
        dispatch(updateLookupData({ data: initData.countryList, type: constant.SlicerLookUpConstant.COUNTRY }));
        dispatch(updateLookupData({ data: initData.stateUSList, type: constant.SlicerLookUpConstant.US_STATE }));
        dispatch(updateLookupData({ data: initData.stateCanadaList, type: constant.SlicerLookUpConstant.CANADA_STATE }));
        dispatch(updateLookupData({ data: initData.genderList, type: constant.SlicerLookUpConstant.GENDER_STATE }));
        dispatch(updateLookupData({ data: initData.individualizedList, type: constant.SlicerLookUpConstant.INDIVIDUALIZED }));
    };

    const EditCustomer = () => {
        setIsEditable(true)
        setFormSaved(false);
        isReset(false)
        setCustomerDetail(prev => {
        const { firstName: parsedFirst, lastName: parsedLast } = parseDisplayName(prev.displayName || '');
        return {
            ...prev,
            firstName: (prev.firstName && prev.firstName.trim() !== '') ? prev.firstName : parsedFirst,
            lastName: (prev.lastName && prev.lastName.trim() !== '') ? prev.lastName : parsedLast,
        };
    });
        firstNameRef.current.focus();
    }

    const deleteCustomer = async () => {
        try {

            let validationResp = await customerDetailService.canDeleteCustomer(id);

            if (validationResp != "CUSTOMER_CAN_BE_DELETED") {
                let errorMessage = validationResp;
                switch (validationResp) {
                    case constant.CUSTOMER_DELETE_INCOMPLETE_TASKS_RESPONSE:
                        errorMessage = constant.CUSTOMER_DELETE_ACTIVE_TASK;
                        break;
                    case constant.CUSTOMER_DELETE_ACTIVE_POLICIES_RESPONSE:
                        errorMessage = constant.CUSTOMER_DELETE_ACTIVE_POLICIES;
                        break;
                    case constant.CUSTOMER_DELETE_INACTIVE_POLICIES_IN_LAST_ONE_YEAR_RESPONSE:
                        errorMessage = constant.CUSTOMER_DELETE_INACIVE_POLICY_IN_LAST_ONE_YEAR;
                        break;
                    case constant.CUSTOMER_DELETE_ACTIVITY_EXISTS:
                        errorMessage = constant.CUSTOMER_DELETE_ACTIVITY_EXISTS_MESSAGE;
                        break;
                    default:
                        errorMessage = constant.CUSTOMER_DELETE_ERROR;
                        break;
                }

                toast.warn(errorMessage, {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }

            let resp: any = await modalContext.showConfirmation(constant.CUSTOMER_DELETE_CONFIRM, constant.CUSTOMER_DELETE_CONFIRM_TITLE, constant.CUSTOMER_DELETE_CONFIRM_TEXT, constant.CUSTOMER_DELETE_CONFIRMATION_TEXT);

            if (!resp.result || resp.data?.toString() != constant.CUSTOMER_DELETE_CONFIRMATION_TEXT) {
                return;
            }

            await customerDetailService.deleteCustomer(id);

            toast.success(constant.CUSTOMER_DELETE_SUCCESS, {
                position: toast.POSITION.TOP_RIGHT
            });

            history.push('/customer/customerfilter');
        }
        catch (ex) {
            if (ex.status == 404) {
                toast.error(constant.CUSTOMER_NOT_FOUND, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
            else {
                toast.error(constant.CUSTOMER_DELETE_ERROR, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    }

    const CancelEdit = async () => {
        const result = await modalContext.showConfirmation(constant.CONFIRM_EXIT)
        if (result) {
            setFormValidation(0)
            setCustomerDetail(intialCustomerDetail)
            isReset(true)
            setIsEditable(false)
            setFormSaved(true);

            if (isCreatingNewCustomer) {
                history.push('/customer/customerfilter');
            }

        }
    }

    const handleEmailClick = (emailAddress) => {
        if (emailAddress != "" && !isEditable) {
            window.open(`mailto:${emailAddress}`, '_blank', 'noopener,noreferrer');
        }
    };

    const handleCopyContactValue = (event: React.MouseEvent<HTMLButtonElement>, value?: string) => {
        event.stopPropagation();

        if (!value || value.trim() === '') {
            return;
        }

        setCopyOverlayTarget(event.currentTarget);
        navigator.clipboard.writeText(value.trim());
        setShowCopyTooltip(true);
        setTimeout(() => {
            setShowCopyTooltip(false);
        }, 500);
    };

    const renderCopyButton = (value?: string) => {
        const hasValue = !!value && value.trim() !== '';

        return (
            <button
                type="button"
                className="input-group-text customer-copy-button"
                title="Copy to clipboard"
                aria-label="Copy to clipboard"
                onClick={(event) => handleCopyContactValue(event, value)}
                disabled={!hasValue}
            >
                <FontAwesomeIcon size="lg" icon={faCopy} />
            </button>
        );
    };

    const SaveCustomer = async () => {
        try {
            let tempCustomerDetail = CommonUtility.deepCloneObject(customerDetail)
            var validationError = customerDetailService.validateCustomer(tempCustomerDetail);      
            var companyWorkPhone = customerDetail.customerContacts.length > 0 ? customerDetail.customerContacts[0].workPhone : null
            if(isStateRequired){


                if(tempCustomerDetail.billZip != '' && tempCustomerDetail.billZip != null){
                tempCustomerDetail.billZip = tempCustomerDetail.billZip?.replace("-", "");
                }
                 if(tempCustomerDetail.zipCode != '' && tempCustomerDetail.zipCode != null){
                tempCustomerDetail.zipCode = tempCustomerDetail.zipCode?.replace("-", "");
                 }

                tempCustomerDetail.customerContacts.map((item) => {
                    if (item.zip != null && item.zip != '') {
                        item.zip = item.zip.replace("-", "")
                     };
                    
                });
          
            };

    
            setFormValidation(validationError);
            if (Object.keys(validationError).length > 0 || (companyWorkPhone != null && companyWorkPhone == "")) {
                toast.warn(constant.CUSTOMER_FORM_VALIDATION_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
                if (companyWorkPhone != null) {
                    if (companyWorkPhone != "") {
                        document.getElementById("companyWorkPhone").classList.remove("is-invalid")
                    } else {
                        document.getElementById("companyWorkPhone").classList.add("is-invalid")
                    }
                }
                return;
            }

            if (tempCustomerDetail.isBillAddressSame) {
                tempCustomerDetail.billAddress1 = tempCustomerDetail.address1,
                    tempCustomerDetail.billAddress2 = tempCustomerDetail.address2,
                    tempCustomerDetail.billCity = tempCustomerDetail.city,
                    tempCustomerDetail.billState = tempCustomerDetail.state,
                    tempCustomerDetail.billZip = tempCustomerDetail.zipCode
            }
            let updatedCustomer = await customerDetailService.saveCustomer(tempCustomerDetail);
            if (updatedCustomer) {
                dispatch(cleareTabsInputs());
                toast.success(constant.CUSTOMER_SAVED_SUCCESSFULLY, {
                    position: toast.POSITION.TOP_RIGHT
                });
                setIsEditable(false)
                setFormSaved(true);
                setCustomerDetail(updatedCustomer)
                setInitialCustomerDetail(updatedCustomer)
                dispatch(updateCustomers(updatedCustomer));
                history.push(`/customer-view/customer/${updatedCustomer.id}`);
            }
            else {
                toast.error(constant.CUSTOMER_ERROR_WHILE_SAVING, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
        catch (e) {
            Logger.logError(constant.CUSTOMER_ERROR_WHILE_SAVING, e);
            if (e.status == 404) {
                toast.error(constant.CUSTOMER_NOT_FOUND, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
            else {
                toast.error(constant.CUSTOMER_ERROR_WHILE_SAVING, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    }

    const tooltip = (< Tooltip id="tooltip" > {constant.ZIPCODE_TOOLTIP} </Tooltip >);

    const handleChangeZipCodeOnBlur = (propName: string, val: string) => {
            if (val) {
                let validationErrors = customerDetailService.validationForZipCode(propName, val, isStateRequired)
                if (Object.keys(validationErrors).length > 0) {
                    setFormValidation({ ...formValidation, ...validationErrors })
                } else {
                    const newObject = { ...formValidation };
                    delete newObject[propName];
                    setFormValidation(newObject);
                }
            }
    };
    const handleTooltip = (value: string, flag: boolean) => {
        setShowTooltip(flag);
        setControl(value);
    }

    const parseDisplayName = (displayName: string): { firstName: string; lastName: string } => {
        if (!displayName) return { firstName: '', lastName: '' };
        const words = displayName.trim().split(/\s+/);
        if (words.length === 1) {
            return { firstName: words[0], lastName: '' };
        }
        return { firstName: words[0], lastName: words.slice(1).join(' ') };
    };
    /// JSX....
    return (
        <>
            <Container fluid id="customer-detail-container">
                <Row className={currentURL === '/customer-new' ? 'customer-detail-panel' : 'customer-height'}>

                    <Column md={8}>
                        <Panel
                            title={cstScrLables.CUSTOMER_INFORMATION}
                            className={'customerPanel cstPanel customerOverview mt-2'}
                            cardBodyClassName="pt-0"
                            collapsible={false}>
                            <Row>
                                <Column lg={12} md={12} className="section-height">
                                    <Row>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['firstName']?.isValid == false ? 'feedback-row' : ''}>
                                            <FloatingLabel
                                                controlId="firstName"
                                                label={<>{cstScrLables.FIRST_NAME}<span className="text-danger ms-1">*</span></>}
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    placeholder={cstScrLables.FIRST_NAME}
                                                    name="firstName"
                                                    ref={firstNameRef}
                                                    value={customerDetail.firstName ?? ""}
                                                    onChange={(event) => onEntityFieldChange('firstName', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    required={true}
                                                    tabIndex={tabIndexCounter++}
                                                    maxLength={60}
                                                    isInvalid={formValidation['firstName']?.isValid == false}
                                                    onKeyDown={(e) => {
                                                        if (e.key == "Tab" && e.shiftKey) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formValidation['firstName']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['firstName']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Column>
                                        <Column lg={contactInoLg} md={contactInoMd}>
                                            <FloatingLabel
                                                controlId="midName"
                                                label={cstScrLables.MIDDLE_NAME}
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    placeholder=" "
                                                    name="midName"
                                                    value={customerDetail.midName ?? ""}
                                                    onChange={(event) => onEntityFieldChange('midName', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    tabIndex={tabIndexCounter++}
                                                    maxLength={60}
                                                />
                                            </FloatingLabel>
                                        </Column>
                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['lastName']?.isValid == false ? 'feedback-row' : ''}>
                                            <FloatingLabel
                                                controlId="lastName"
                                                label={<>{cstScrLables.LAST_NAME}<span className="text-danger ms-1">*</span></>}
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    placeholder={cstScrLables.LAST_NAME}
                                                    name="lastName"
                                                    value={customerDetail.lastName ?? ""}
                                                    onChange={(event) => onEntityFieldChange('lastName', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    required
                                                    tabIndex={tabIndexCounter++}
                                                    maxLength={60}
                                                    isInvalid={formValidation['lastName']?.isValid == false}
                                                />
                                                {formValidation['lastName']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['lastName']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={8} md={8}
                                            className={formValidation['displayName']?.isValid == false ? 'feedback-row' : ''}>
                                            <FloatingLabel
                                                controlId="displayName"
                                                label={<>{cstScrLables.DISPLAY_NAME}<span className="text-danger ms-1">*</span></>}
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    placeholder={cstScrLables.DISPLAY_NAME}
                                                    name="displayName"
                                                    value={customerDetail.displayName ?? ""}
                                                    onChange={(event) => onEntityFieldChange('displayName', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    required
                                                    tabIndex={tabIndexCounter++}
                                                    maxLength={100}
                                                    isInvalid={formValidation['displayName']?.isValid == false}
                                                />
                                                {formValidation['displayName']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['displayName']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Column>

                                        <Column lg={contactInoLg} md={contactInoMd}>
                                            <Select
                                                id="ddGenderList"
                                                controlId="ddGenderList"
                                                className='mb-3'
                                                label={cstScrLables.GENDER}
                                                options={genders}
                                                defaultSelected={genders.filter(option =>
                                                    option.value === customerDetail.gender
                                                )}
                                                onChange={(values) => onEntityFieldChange('gender', values[0] as string)}
                                                disabled={!isEditable}
                                                tabIndex={tabIndexCounter++}
                                                isInvalid={formValidation['gender']?.isValid == false}
                                                invalidWarning={formValidation['gender']?.warningText}
                                            />
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={contactInoLg} md={contactInoMd}>
                                            <Select
                                                id="ddIndustryId"
                                                controlId="ddIndustryId"
                                                className='mb-3'
                                                label={cstScrLables.INDUSTRY}
                                                options={industries}
                                                onChange={(values) => onEntityFieldChange('industryId', values[0] as string)}
                                                disabled={!isEditable}
                                                tabIndex={tabIndexCounter++}
                                                defaultSelected={industries.filter(option =>
                                                    option.value === customerDetail.industryId
                                                )}
                                                isInvalid={formValidation['industryId']?.isValid == false}
                                                invalidWarning={formValidation['industryId']?.warningText}
                                            />
                                        </Column>

                                        <Column lg={contactInoLg} md={contactInoMd}>
                                            <Select
                                                id="ddOccupation"
                                                controlId="ddOccupation"
                                                className='mb-3'
                                                label={cstScrLables.OCCUPATION}
                                                options={occupancies}
                                                defaultSelected={occupancies.filter(option =>
                                                    option.value === customerDetail.occupationId
                                                )}
                                                onChange={(values) => onEntityFieldChange('occupationId', values[0] as string)}
                                                disabled={!isEditable}
                                                tabIndex={tabIndexCounter++}
                                                isInvalid={formValidation['occupationId']?.isValid == false}
                                                invalidWarning={formValidation['occupationId']?.warningText}
                                            />
                                        </Column>

                                        <Column lg={contactInoLg} md={contactInoMd}
                                            className={formValidation['yearEmployed']?.isValid == false ? 'feedback-row' : ''}>
                                            <FloatingLabel
                                                controlId="yearEmployed"
                                                label={cstScrLables.YEAR_EMPLOYED}
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="number"
                                                    placeholder=" "
                                                    name="yearEmployed"
                                                    value={customerDetail.yearEmployed ?? ""}
                                                    onChange={(e) => onEntityFieldChange('yearEmployed', e.target.value)}
                                                    disabled={!isEditable}
                                                    tabIndex={tabIndexCounter++}
                                                    maxLength={4}
                                                    isInvalid={formValidation['yearEmployed']?.isValid == false}
                                                    onKeyDown={(e) => {
                                                        addContactButtonRef.current?.scrollIntoView({ block: "end" })
                                                    }}
                                                />
                                                {formValidation['yearEmployed']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['yearEmployed']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                        </Column>
                                    </Row>
                                    <Row className="cstErrorTopMargin">
                                        <Column lg={4} md={4}>
                                            <Select
                                                id="maritalStatusId"
                                                controlId="maritalStatusId"
                                                className='mb-3'
                                                label={cstScrLables.MARITAL_STATUS}
                                                options={maritalStatuses}
                                                defaultSelected={maritalStatuses.filter(option =>
                                                    option.value === customerDetail.maritalStatusId
                                                )}
                                                onChange={(values) => onEntityFieldChange('maritalStatusId', values[0] as string)}
                                                disabled={!isEditable}
                                                tabIndex={tabIndexCounter++}
                                                isInvalid={formValidation['maritalStatusId']?.isValid == false}
                                                invalidWarning={formValidation['maritalStatusId']?.warningText}
                                            />
                                        </Column>

                                        <Column lg={4} md={4}
                                            className={formValidation['agencyId']?.isValid == false ? 'feedback-row' : ''}>
                                            <Select
                                                id="agencyId"
                                                controlId="agencyId"
                                                className='mb-3'
                                                label={<>{cstScrLables.AGENCY}<span className="text-danger ms-1">*</span></>}
                                                options={agencies}
                                                defaultSelected={agencies.filter(option =>
                                                    option.value === customerDetail.agencyId
                                                )}
                                                onChange={(values) => onEntityFieldChange('agencyId', values[0] as string)}
                                                disabled={!isEditable}
                                                tabIndex={tabIndexCounter++}
                                                isInvalid={formValidation['agencyId']?.isValid == false}
                                                invalidWarning={formValidation['agencyId']?.warningText}
                                            />
                                        </Column>

                                        <Column lg={4} md={4}>
                                            <Row>
                                                {
                                                    !isCreatingNewCustomer &&
                                                    <Column lg={6} md={6}>
                                                        <FloatingLabel
                                                            controlId="legacyNotationCode"
                                                            label={<>{cstScrLables.LEGACY_NOTATION_CODE}</>}
                                                            className="mb-3"
                                                        >
                                                            <Form.Control
                                                                type="text"
                                                                placeholder={cstScrLables.LEGACY_NOTATION_CODE}
                                                                name="legacyNotationCode"
                                                                value={customerDetail.legacyNotationCode ?? ""}
                                                                disabled={true}
                                                            />
                                                        </FloatingLabel>
                                                    </Column>
                                                }
                                                <Column lg={6} md={6}>
                                                    <Form.Check
                                                        id="chkVip"
                                                        label={cstScrLables.VIP}
                                                        checked={customerDetail.vip}
                                                        onChange={(event) => toggleEntityField('vip')}
                                                        disabled={!isEditable ? true: !isUserPermitToUpdateVip}
                                                        className="mt-3"
                                                        tabIndex={tabIndexCounter++}
                                                    />
                                                </Column>
                                            </Row>
                                        </Column>
                                    </Row>
                                    <Row className="cstErrorTopMargin">
                                        <Column lg={4} md={4}>
                                            <Select
                                                id="individualizedId"
                                                controlId="individualizedId"
                                                className='mb-3'
                                                label={cstScrLables.INDIVIDUALIZED}
                                                options={individualizedList}
                                                defaultSelected={individualizedList.filter(option =>
                                                    option.value === customerDetail.individualizedId
                                                )}
                                                onChange={(values) => onEntityFieldChange('individualizedId', values[0] as string)}
                                                disabled={!isEditable}
                                                tabIndex={tabIndexCounter++}
                                                isInvalid={formValidation['individualizedId']?.isValid == false}
                                                invalidWarning={formValidation['individualizedId']?.warningText}
                                            />
                                        </Column>
                                    </Row>
                                    {/* <Row className="cstErrorTopMargin">
                                        <Column lg={4} md={4}>
                                        </Column>
                                        <Column lg={4} md={4}>
                                        </Column>
                                        <Column lg={4} md={4}>
                                          <Row> 
                                                <Column lg={6} md={6}>
                                                    <Form.Check
                                                        id="chkBuilderLeaseBack"
                                                        label={cstScrLables.BUILDER_LEASE_BACK}
                                                        checked={true}
                                                        onChange={(event) => toggleEntityField('builderLeaseBack')}
                                                        disabled={true}
                                                        className="mt-3"
                                                    />
                                                </Column>
                                                 <Column lg={6} md={6}>
                                                    <Form.Check
                                                        id="chkMultiPolicy"
                                                        label={cstScrLables.MULTI_POLICY}
                                                        checked={true}
                                                        onChange={(event) => toggleEntityField('multiPolicy')}
                                                        disabled={true}
                                                        className="mt-3"
                                                    />
                                                </Column>
                                            </Row>
                                        </Column>
                                    </Row> */}

                                </Column>

                            </Row>
                        </Panel>

                        <Panel
                            title={'Address Information'}
                            className={'customerPanel cstPanel mt-2'}
                            cardBodyClassName="pt-0"
                        >
                            <div>
                                <div className="d-flex justify-content-between">
                                    <h6 className="text-uppercase">MAILING ADDRESS</h6>

                                    <Form.Check
                                        id="chkIsBillAddressSame"
                                        label={cstScrLables.SAME_AS_MAILING}
                                        checked={customerDetail.isBillAddressSame}
                                        onChange={(event) => populateBillingAddress(event)}
                                        disabled={!isEditable}
                                        tabIndex={tabIndexCounter++}
                                    />
                                </div>

                                {/* Address Line 1 */}
                                <Row className="">
                                    <Column lg={5} md={5}>
                                        <Select
                                            id="country"
                                            controlId="country"
                                            label={cstScrLables.COUNTRY}
                                            options={countries}
                                            defaultSelected={countries?.filter(({ value }) => value === (customerDetail.countryId))}
                                            onChange={
                                                (values) => {
                                                    onEntityFieldChange('countryId', values[0] as string)
                                                    onCountrySelection(values[0] as string)
                                                    setFormValidation({ ...formValidation, 'billZip':{ isValid: true, warningText: ''}, 'zipCode':{ isValid: true, warningText: '' } });
                                                }
                                            }
                                            disabled={!isEditable}
                                            tabIndex={tabIndexCounter++}
                                            className='mb-3'
                                        />
                                    </Column>
                                </Row>
                                <Row className="">
                                    <Column lg={8} md={8}
                                        className={formValidation['address1']?.isValid == false ? 'feedback-row' : ''}>
                                        <FloatingLabel
                                            controlId="address1"
                                            label={<>
                                                {cstScrLables.ADDRESS_1}
                                                <span className="text-danger ms-1">*</span>
                                            </>}
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                type="text"
                                                placeholder=" "
                                                name="address1"
                                                value={customerDetail.address1 ?? ""}
                                                onChange={(event) => onEntityFieldChange('address1', event.currentTarget.value)}
                                                onKeyDown={(e) => {
                                                    addContactButtonRef.current?.scrollIntoView({ block: "end" })
                                                }}
                                                disabled={!isEditable}
                                                required
                                                tabIndex={tabIndexCounter++}
                                                maxLength={100}
                                                isInvalid={formValidation['address1']?.isValid == false}
                                            />
                                            {formValidation['address1']?.isValid == false && (
                                                <Form.Control.Feedback type="invalid">
                                                    {formValidation['address1']?.warningText}
                                                </Form.Control.Feedback>
                                            )}
                                        </FloatingLabel>
                                    </Column>

                                    <Column lg={4} md={4}>
                                        <FloatingLabel
                                            controlId="address2"
                                            label={cstScrLables.ADDRESS_2}
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                type="text"
                                                placeholder=" "
                                                name="address2"
                                                value={customerDetail.address2 ?? ""}
                                                onChange={(event) => onEntityFieldChange('address2', event.currentTarget.value)}
                                                disabled={!isEditable}
                                                tabIndex={tabIndexCounter++}
                                                maxLength={100}
                                            />
                                        </FloatingLabel>
                                    </Column>
                                </Row>

                                {/* Address Line 2 */}
                                <Row className="">
                                    <Column lg={5} md={5}
                                        className={formValidation['city']?.isValid == false ? 'feedback-row' : ''}>
                                        <FloatingLabel
                                            controlId="city"
                                            label={<>
                                                {cstScrLables.CITY}
                                                <span className="text-danger ms-1">*</span>
                                            </>}
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                type="text"
                                                placeholder=" "
                                                name="city"
                                                value={customerDetail.city ?? ""}
                                                onChange={(event) => onEntityFieldChange('city', event.currentTarget.value)}
                                                disabled={!isEditable}
                                                required
                                                tabIndex={tabIndexCounter++}
                                                maxLength={100}
                                                isInvalid={formValidation['city']?.isValid == false}
                                            />
                                            {formValidation['city']?.isValid == false && (
                                                <Form.Control.Feedback type="invalid">
                                                    {formValidation['city']?.warningText}
                                                </Form.Control.Feedback>
                                            )}
                                        </FloatingLabel>
                                    </Column>

                                    <Column lg={4} md={4}>
                                        {
                                            isStateAsDropdown ?
                                                <Select
                                                    id="state"
                                                    controlId="state"
                                                    label={<>{cstScrLables.STATE} {isStateRequired && <span className="text-danger ms-1">*</span>}</>}
                                                    options={states}
                                                    defaultSelected={states.filter(option =>
                                                        option.value === customerDetail.state
                                                    )}
                                                    onChange={(values) => onEntityFieldChange('state', values[0] as string)}
                                                    disabled={!isEditable}
                                                    tabIndex={tabIndexCounter++}
                                                    isInvalid={formValidation['state']?.isValid == false}
                                                    invalidWarning={formValidation['state']?.warningText}
                                                    className='mb-3'
                                                />
                                                :
                                                <FloatingLabel
                                                    controlId="txtState"
                                                    label={<>
                                                        {cstScrLables.STATE}
                                                    </>}
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        placeholder=" "
                                                        name="txtState"
                                                        value={customerDetail.state ?? ""}
                                                        onChange={(event) => onEntityFieldChange('state', event.currentTarget.value)}
                                                        disabled={!isEditable}
                                                        tabIndex={tabIndexCounter++}
                                                        maxLength={100}
                                                        isInvalid={formValidation['state']?.isValid == false}
                                                    />
                                                    {formValidation['state']?.isValid == false && (
                                                        <Form.Control.Feedback type="invalid">
                                                            {formValidation['state']?.warningText}
                                                        </Form.Control.Feedback>
                                                    )}
                                                </FloatingLabel>
                                        }
                                    </Column>

                                    <Column lg={3} md={3}
                                        className={formValidation['zipCode']?.isValid == false ? 'feedback-row' : ''}>
                                        <TextInputWithZipCode
                                            name="zipCode"
                                            label={cstScrLables.ZIP}
                                            controlId="zipCode"
                                            value={customerDetail.zipCode ?? ""}
                                            onChange={(event) => {
                                                onEntityFieldChange('zipCode', event.currentTarget.value);
                                            } }
                                            onKeyDown={() => {
                                                return addContactButtonRef.current?.scrollIntoView({ block: "end" });
                                            } }
                                            onBlur={(e) => handleChangeZipCodeOnBlur('zipCode', customerDetail.zipCode)}
                                            onMouseEnter={() => handleTooltip('zipCode', true)}
                                            onMouseLeave={() => handleTooltip('zipCode', false)}
                                            disabled={!isEditable}
                                            required
                                            tabIndex={tabIndexCounter++}
                                            maxLength={isStateRequired ? 10: 9}
                                            isInvalid={formValidation['zipCode']?.isValid == false}
                                            invalidWarning={formValidation['zipCode']?.warningText} type={'text'}
                                            isUSA={isStateRequired}
                                        />
                                    </Column>
                                </Row>

                                <Row>
                                    <Column lg={12} md={12}>

                                    </Column>
                                </Row>

                                <div className={`${customerDetail.isBillAddressSame === true ? 'hidden' : ''}`}>
                                    <h6 className="text-uppercase">Billing Address</h6>

                                    {/* Billing Address Line 1 */}
                                    <Row>
                                        <Column lg={8} md={8}>
                                            <FloatingLabel
                                                controlId="billAddress1"
                                                label={cstScrLables.ADDRESS_1}
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    placeholder=" "
                                                    name="billAddress1"
                                                    value={customerDetail.billAddress1 ?? ""}
                                                    onChange={(event) => onEntityFieldChange('billAddress1', event.currentTarget.value)}
                                                    disabled={customerDetail.isBillAddressSame === true ? true : !isEditable}
                                                    tabIndex={tabIndexCounter++}
                                                    maxLength={100}
                                                />
                                            </FloatingLabel>
                                        </Column>

                                        <Column lg={4} md={4}>
                                            <FloatingLabel
                                                controlId="billAddress2"
                                                label={cstScrLables.ADDRESS_2}
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    placeholder=" "
                                                    name="billAddress2"
                                                    value={customerDetail.billAddress2 ?? ""}
                                                    onChange={(event) => onEntityFieldChange('billAddress2', event.currentTarget.value)}
                                                    disabled={customerDetail.isBillAddressSame === true ? true : !isEditable}
                                                    tabIndex={tabIndexCounter++}
                                                    maxLength={100}
                                                />
                                            </FloatingLabel>
                                        </Column>
                                    </Row>

                                    {/* Billing Address Line 2 */}
                                    <Row>
                                        <Column lg={5} md={5}>
                                            <FloatingLabel
                                                controlId="billCity"
                                                label={cstScrLables.CITY}
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    placeholder=" "
                                                    name="billCity"
                                                    value={customerDetail.billCity ?? ""}
                                                    onChange={(event) => onEntityFieldChange('billCity', event.currentTarget.value)}
                                                    disabled={customerDetail.isBillAddressSame === true ? true : !isEditable}
                                                    tabIndex={tabIndexCounter++}
                                                    maxLength={100}
                                                />
                                            </FloatingLabel>
                                        </Column>

                                        <Column lg={4} md={4}>
                                            {
                                                isStateAsDropdown ?
                                                    <Select
                                                        id="billState"
                                                        controlId="billState"
                                                        label={<>{cstScrLables.STATE} {isStateRequired && !customerDetail.isBillAddressSame && <span className="text-danger ms-1">*</span>}</>}
                                                        options={states}
                                                        defaultSelected={states.filter(option =>
                                                            option.value === customerDetail.billState
                                                        )}
                                                        onChange={(values) => onEntityFieldChange('billState', values[0] as string)}
                                                        disabled={customerDetail.isBillAddressSame === true ? true : !isEditable}
                                                        tabIndex={tabIndexCounter++}
                                                        isInvalid={formValidation['billState']?.isValid == false}
                                                        invalidWarning={formValidation['billState']?.warningText}
                                                        className='mb-3'
                                                    />
                                                    :
                                                    <FloatingLabel
                                                        controlId="txtBillState"
                                                        label={<>
                                                            {cstScrLables.STATE}
                                                        </>}
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            placeholder=" "
                                                            name="txtBillState"
                                                            value={customerDetail.billState ?? ""}
                                                            onChange={(event) => onEntityFieldChange('billState', event.currentTarget.value)}
                                                            disabled={customerDetail.isBillAddressSame === true ? true : !isEditable}
                                                            tabIndex={tabIndexCounter++}
                                                            maxLength={100}
                                                            isInvalid={formValidation['billState']?.isValid == false}
                                                        />
                                                        {formValidation['billState']?.isValid == false && (
                                                            <Form.Control.Feedback type="invalid">
                                                                {formValidation['billState']?.warningText}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </FloatingLabel>
                                            }
                                        </Column>
                                        <Column lg={3} md={3}
                                            className={formValidation['billZip']?.isValid == false ? 'feedback-row' : ''}>
                                            <TextInputWithZipCode
                                                name="billZip"
                                                label={cstScrLables.ZIP}
                                                controlId="billZip"
                                                value={customerDetail.billZip ?? ""}
                                                onChange={(event) => {
                                                    onEntityFieldChange('billZip', event.currentTarget.value);
                                                }}
                                                onKeyDown={() => {
                                                    return addContactButtonRef.current?.scrollIntoView({ block: "end" });
                                                }}
                                                onBlur={(e) => handleChangeZipCodeOnBlur('billZip', customerDetail.billZip)}
                                                onMouseEnter={() => handleTooltip('billZip', true)}
                                                onMouseLeave={() => handleTooltip('billZip', false)}
                                                disabled={customerDetail.isBillAddressSame === true ? true : !isEditable}
                                                tabIndex={tabIndexCounter++}
                                                maxLength={isStateRequired ? 10: 9}
                                                isInvalid={formValidation['billZip']?.isValid == false}
                                                invalidWarning={formValidation['billZip']?.warningText} type={'text'}
                                                isUSA={isStateRequired}
                                            />
                                        </Column>
                                    </Row>
                                </div>
                            </div>

                        </Panel>

                        <Panel title={cstScrLables.ADDITIONAL_CUSTOMER_INFORMATION}
                            className={'customerPanel cstPanel cstCustAlign clear-card-body mt-2'}
                            panelHeaderItems={customerDependentsPanelHeaderItems}
                            cardBodyClassName='dpd-crd-body'
                            collapsible={false}>
                            {customerDependentView}
                        </Panel>
                        <Panel title={constant.CompanyContact.COMPANY_CONATCT}
                            className={'customerPanel cstPanel cstCustAlign clear-card-body mt-2'}
                            panelHeaderItems={customerCompanyContsctsPanelHeaderItems}
                            cardBodyClassName='dpd-crd-body'
                            collapsible={false}>
                            {customerContactView}
                        </Panel>
                    </Column>

                    <Column md={4}>
                        <div className="contacts-sidebar sticky-top mt-2 me-2" style={{ top: '1rem' }}>
                            <Panel
                                title={'Contact Information'}
                                cardBodyClassName="pt-0"
                                className={'customerPanel cstPanel'}>
                                <Row className="mb-2">
                                    <Column lg={6} md={6}>
                                        <Checkbox
                                            id='chkmailOptOut'
                                            label={cstScrLables.DO_NOT_MAIL}
                                            checked={customerDetail.mailOptOut}
                                            onChange={(event) => toggleEntityField('mailOptOut')}
                                            disabled={!isEditable}
                                            checkboxStyle={{ position: "relative", marginRight: "5px" }}
                                            tabIndex={275}
                                        />
                                    </Column>
                                    <Column lg={6} md={6}>
                                        <Checkbox
                                            id='chkcallOptOut'
                                            label={cstScrLables.DO_NOT_CALL}
                                            checked={customerDetail.callOptOut}
                                            onChange={(event) => toggleEntityField('callOptOut')}
                                            disabled={!isEditable}
                                            checkboxStyle={{ position: "relative", marginRight: "5px" }}
                                            tabIndex={280}
                                        />
                                    </Column>
                                </Row>
                                <Row className="mb-2">
                                    <Column lg={6} md={6}>
                                        <Checkbox
                                            id='chkemailOptOut'
                                            label={cstScrLables.DO_NOT_EMAIL}
                                            checked={customerDetail.emailOptOut}
                                            onChange={(event) => toggleEntityField('emailOptOut')}
                                            disabled={!isEditable}
                                            tabIndex={285}
                                            checkboxStyle={{ position: "relative", marginRight: "5px" }}
                                        />
                                    </Column>
                                    <Column lg={6} md={6}>
                                        <Checkbox
                                            id='chkeddOptIn'
                                            label={cstScrLables.EDD_OPT_IN}
                                            checked={customerDetail.eddOptIn}
                                            onChange={(event) => toggleEntityField('eddOptIn')}
                                            disabled={!isEditable}
                                            tabIndex={290}
                                            checkboxStyle={{ position: "relative", marginRight: "5px" }}
                                        />
                                    </Column>
                                </Row>
                                <Row className="mb-2">
                                    <Column lg={6} md={6}>
                                        <Checkbox
                                            id='chksmsOptOut'
                                            label={cstScrLables.SMS_OPT_OUT}
                                            checked={customerDetail.smsOptOut}
                                            onChange={(event) => toggleEntityField('smsOptOut')}
                                            disabled={!isEditable}
                                            tabIndex={295}
                                            checkboxStyle={{ position: "relative", marginRight: "5px" }}
                                        />
                                    </Column>
                                </Row>
                                <hr />
                                
                                {/* Home Phone */}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['homePhone']?.isValid == false ? 'feedback-row' : ''}>
                                        <div className="input-group has-validation">
                                            <span className="input-group-text remove-right-radius mb-3">
                                                <Icon icon="home" className="text-muted fa-fw" />
                                            </span>
                                            <FloatLabel>
                                                <InputMask
                                                    name="homePhone"
                                                    value={customerDetail.homePhone}
                                                    onChange={(event) => onEntityFieldChange('homePhone', event.value)}
                                                    disabled={!isEditable}
                                                    mask="999-999-9999"
                                                    autoClear={false}
                                                    tabIndex={296}
                                                    className={formValidation['homePhone']?.isValid == false ? 'p-invalid' : ''}
                                                    placeholder="" />
                                                <label>{cstScrLables.HOME_PHONE}</label>
                                            </FloatLabel>
                                            {renderCopyButton(customerDetail.homePhone)}
                                        </div>
                                        {formValidation['homePhone']?.isValid == false && (
                                            <div className="invalid-feedback d-block" style={{marginTop: '-0.5rem'}}>
                                                {formValidation['homePhone']?.warningText}
                                            </div>
                                        )}
                                    </Column>
                                </Row>
                                )}

                                {/* Work Phone */}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['workPhone']?.isValid == false ? 'feedback-row' : ''}>
                                        <div className="input-group has-validation">
                                            <span className="input-group-text remove-right-radius mb-3">
                                                <Icon icon="building" className="text-muted fa-fw" />
                                            </span>
                                            <FloatLabel>
                                                <InputMask
                                                    name="workPhone"
                                                    value={customerDetail.workPhone}
                                                    onChange={(event) => onEntityFieldChange('workPhone', event.value)}
                                                    disabled={!isEditable}
                                                    mask="999-999-9999"
                                                    autoClear={false}
                                                    tabIndex={297}
                                                    className={formValidation['workPhone']?.isValid == false ? 'p-invalid' : ''}
                                                    placeholder="" />
                                                <label>{cstScrLables.WORK_PHONE}</label>
                                            </FloatLabel>
                                            {renderCopyButton(customerDetail.workPhone)}
                                            <div className="input-group-text" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
                                                <Checkbox
                                                    id='chkWorkPhoneSmsOptIn'
                                                    label={""}
                                                    checked={customerDetail.workPhoneSmsOptIn}
                                                    onChange={(event) => toggleEntityField('workPhoneSmsOptIn')}
                                                    disabled={!isEditable || customerDetail.smsOptOut}
                                                    checkboxStyle={{ position: "relative", marginRight: "5px" }}
                                                    tabIndex={298}
                                                />
                                            </div>
                                        </div>
                                        {formValidation['workPhone']?.isValid == false && (
                                            <div className="invalid-feedback d-block" style={{marginTop: '-0.5rem'}}>
                                                {formValidation['workPhone']?.warningText}
                                            </div>
                                        )}
                                    </Column>
                                </Row>
                                )}
                                {/* Cell Phone */}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['Phone']?.isValid == false ? 'feedback-row' : ''}>

                                        <div className="input-group has-validation">
                                            <span className="input-group-text remove-right-radius mb-3">
                                                <Icon icon="mobile" className="text-muted fa-fw" />
                                            </span>
                                            <FloatLabel>
                                                <InputMask
                                                    name="mobile"
                                                    value={customerDetail.mobile}
                                                    onChange={(event) => onEntityFieldChange('mobile', event.value)}
                                                    disabled={!isEditable}
                                                    mask="999-999-9999"
                                                    autoClear={false}
                                                    tabIndex={300}
                                                    className={formValidation['Phone']?.isValid == false ? 'p-invalid' : ''}
                                                    placeholder="" />
                                                <label>{cstScrLables.CELL_PHONE}</label>
                                            </FloatLabel>
                                            {renderCopyButton(customerDetail.mobile)}
                                            <div className="input-group-text" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, overflow: 'hidden' }}>
                                                <Checkbox
                                                    id='chkMobileSmsOptIn'
                                                    label={""}
                                                    checked={customerDetail.mobileSmsOptIn}
                                                    onChange={(event) => toggleEntityField('mobileSmsOptIn')}
                                                    disabled={!isEditable || customerDetail.smsOptOut}
                                                    checkboxStyle={{ position: "relative", marginRight: "5px" }}
                                                    tabIndex={301}
                                                />
                                            </div>
                                        </div>
                                        {formValidation['Phone']?.isValid == false && (
                                            <div className="invalid-feedback d-block" style={{marginTop: '-0.5rem'}}>
                                                {formValidation['Phone']?.warningText}
                                            </div>
                                        )}
                                    </Column>
                                </Row>
                                )}

                                {/* Other Phone 1*/}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['otherPhone1']?.isValid == false ? 'feedback-row' : ''}>

                                        <div className="input-group has-validation">
                                            <span className="input-group-text remove-right-radius mb-3">
                                                <Icon icon="mobile" className="text-muted fa-fw" />
                                            </span>
                                            <FloatLabel>
                                                <InputMask
                                                    name="otherPhone1"
                                                    value={customerDetail.otherPhone1}
                                                    onChange={(event) => onEntityFieldChange('otherPhone1', event.value)}
                                                    disabled={!isEditable}
                                                    mask="999-999-9999"
                                                    autoClear={false}
                                                    tabIndex={302}
                                                    className={formValidation['otherPhone1']?.isValid == false ? 'p-invalid' : ''}
                                                    placeholder="" />
                                                <label>{cstScrLables.OTHER_PHONE1}</label>
                                            </FloatLabel>
                                            {renderCopyButton(customerDetail.otherPhone1)}
                                            <div className="input-group-text" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, overflow: 'hidden' }}>
                                                <Checkbox
                                                    id='chkOtherPhone1SmsOptIn'
                                                    label={""}
                                                    checked={customerDetail.otherPhone1SmsOptIn}
                                                    onChange={(event) => toggleEntityField('otherPhone1SmsOptIn')}
                                                    disabled={!isEditable || customerDetail.smsOptOut}
                                                    checkboxStyle={{ position: "relative", marginRight: "5px" }}
                                                    tabIndex={303}
                                                />
                                            </div>
                                        </div>
                                        {formValidation['otherPhone1']?.isValid == false && (
                                            <div className="invalid-feedback d-block" style={{marginTop: '-0.5rem'}}>
                                                {formValidation['otherPhone1']?.warningText}
                                            </div>
                                        )}
                                    </Column>
                                </Row>
                                )}
                                {/* Other Phone 2*/}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['otherPhone2']?.isValid == false ? 'feedback-row' : ''}>

                                        <div className="input-group has-validation">
                                            <span className="input-group-text remove-right-radius mb-3">
                                                <Icon icon="mobile" className="text-muted fa-fw" />
                                            </span>
                                            <FloatLabel>
                                                <InputMask
                                                    name="otherPhone2"
                                                    value={customerDetail.otherPhone2}
                                                    onChange={(event) => onEntityFieldChange('otherPhone2', event.value)}
                                                    disabled={!isEditable}
                                                    mask="999-999-9999"
                                                    autoClear={false}
                                                    tabIndex={304}
                                                    className={formValidation['otherPhone2']?.isValid == false ? 'p-invalid' : ''}
                                                    placeholder="" />
                                                <label>{cstScrLables.OTHER_PHONE2}</label>
                                            </FloatLabel>
                                            {renderCopyButton(customerDetail.otherPhone2)}
                                            <div className="input-group-text" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, overflow: 'hidden' }}>
                                                <Checkbox
                                                    id='chkOtherPhone2SmsOptIn'
                                                    label={""}
                                                    checked={customerDetail.otherPhone2SmsOptIn}
                                                    onChange={(event) => toggleEntityField('otherPhone2SmsOptIn')}
                                                    disabled={!isEditable || customerDetail.smsOptOut}
                                                    checkboxStyle={{ position: "relative", marginRight: "5px" }}
                                                    tabIndex={305}
                                                />
                                            </div>
                                        </div>
                                        {formValidation['otherPhone2']?.isValid == false && (
                                            <div className="invalid-feedback d-block" style={{marginTop: '-0.5rem'}}>
                                                {formValidation['otherPhone2']?.warningText}
                                            </div>
                                        )}
                                    </Column>
                                </Row>
                                )}
                                {/* Other Phone 3*/}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['otherPhone3']?.isValid == false ? 'feedback-row' : ''}>

                                        <div className="input-group has-validation">
                                            <span className="input-group-text remove-right-radius mb-3">
                                                <Icon icon="mobile" className="text-muted fa-fw" />
                                            </span>
                                            <FloatLabel>
                                                <InputMask
                                                    name="otherPhone3"
                                                    value={customerDetail.otherPhone3}
                                                    onChange={(event) => onEntityFieldChange('otherPhone3', event.value)}
                                                    disabled={!isEditable}
                                                    mask="999-999-9999"
                                                    autoClear={false}
                                                    tabIndex={306}
                                                    className={formValidation['otherPhone3']?.isValid == false ? 'p-invalid' : ''}
                                                    placeholder="" />
                                                <label>{cstScrLables.OTHER_PHONE3}</label>
                                            </FloatLabel>
                                            {renderCopyButton(customerDetail.otherPhone3)}
                                            <div className="input-group-text" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, overflow: 'hidden' }}>
                                                <Checkbox
                                                    id='chkOtherPhone3SmsOptIn'
                                                    label={""}
                                                    checked={customerDetail.otherPhone3SmsOptIn}
                                                    onChange={(event) => toggleEntityField('otherPhone3SmsOptIn')}
                                                    disabled={!isEditable || customerDetail.smsOptOut}
                                                    checkboxStyle={{ position: "relative", marginRight: "5px" }}
                                                    tabIndex={307}
                                                />
                                            </div>
                                        </div>
                                        {formValidation['otherPhone3']?.isValid == false && (
                                            <div className="invalid-feedback d-block" style={{marginTop: '-0.5rem'}}>
                                                {formValidation['otherPhone3']?.warningText}
                                            </div>
                                        )}
                                    </Column>
                                </Row>
                                )}
                                {/* Email 1 */}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['eMail']?.isValid == false ? 'feedback-row' : ''}
                                    >

                                        <div className="input-group has-validation mb-3" onClick={() => handleEmailClick(customerDetail.eMail ?? "")}>
                                            <span className={`input-group-text remove-right-radius ${!isEditable && customerDetail.eMail ? 'click-wrapper ' : ''}`}>
                                                <Icon icon="email" className={`text-muted fa-fw ${!isEditable && customerDetail.eMail ? 'customer-detail-icon' : ''}`} />
                                            </span>
                                            <FloatingLabel controlId="email1" label={cstScrLables.EMAIL_1} >

                                                <Form.Control
                                                    type="email"
                                                    placeholder=" "
                                                    name="eMail"
                                                    value={customerDetail.eMail ?? ""}
                                                    onChange={(event) => onEntityFieldChange('eMail', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    tabIndex={315}
                                                    maxLength={150}
                                                    isInvalid={formValidation['eMail']?.isValid == false}
                                                    className={''}
                                                />
                                                {formValidation['eMail']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['eMail']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                            {renderCopyButton(customerDetail.eMail)}
                                        </div>
                                    </Column>
                                </Row>
                                )}

                                {/* Email 2 */}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['eMail2']?.isValid == false ? 'feedback-row' : ''}>
                                        <div className="input-group has-validation mb-3" onClick={() => handleEmailClick(customerDetail.eMail2 ?? "")}>
                                            <span className={`input-group-text remove-right-radius ${!isEditable && customerDetail.eMail2 ? 'click-wrapper ' : ''}`}>
                                                <Icon icon="email" className={`text-muted fa-fw ${!isEditable && customerDetail.eMail2 ? 'customer-detail-icon' : ''}`} />
                                            </span>
                                            <FloatingLabel controlId="email2" label={cstScrLables.EMAIL_2}>
                                                <Form.Control
                                                    type="email"
                                                    placeholder=" "
                                                    name="eMail2"
                                                    value={customerDetail.eMail2 ?? ""}
                                                    onChange={(event) => onEntityFieldChange('eMail2', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    tabIndex={320}
                                                    maxLength={150}
                                                    isInvalid={formValidation['eMail2']?.isValid == false}
                                                />
                                                {formValidation['eMail2']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['eMail2']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                            {renderCopyButton(customerDetail.eMail2)}
                                            {/*<div className="click-overlay" ></div>*/}
                                        </div>
                                    </Column>
                                </Row>
                                )}
                                {/* Email 3 */}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['email3']?.isValid == false ? 'feedback-row' : ''}>
                                        <div className="input-group has-validation mb-3" onClick={() => handleEmailClick(customerDetail.email3 ?? "")}>
                                            <span className={`input-group-text remove-right-radius ${!isEditable && customerDetail.email3 ? 'click-wrapper ' : ''}`}>
                                                <Icon icon="email" className={`text-muted fa-fw ${!isEditable && customerDetail.email3 ? 'customer-detail-icon' : ''}`} />
                                            </span>
                                            <FloatingLabel controlId="email3" label={cstScrLables.EMAIL_3}>
                                                <Form.Control
                                                    type="email"
                                                    placeholder=" "
                                                    name="email3"
                                                    value={customerDetail.email3 ?? ""}
                                                    onChange={(event) => onEntityFieldChange('email3', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    tabIndex={321}
                                                    maxLength={150}
                                                    isInvalid={formValidation['email3']?.isValid == false}
                                                />
                                                {formValidation['email3']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['email3']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                            {renderCopyButton(customerDetail.email3)}
                                            {/*<div className="click-overlay" ></div>*/}
                                        </div>
                                    </Column>
                                </Row>
                                )}
                                {/* Email 4 */}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['email4']?.isValid == false ? 'feedback-row' : ''}>
                                        <div className="input-group has-validation mb-3" onClick={() => handleEmailClick(customerDetail.email4 ?? "")}>
                                            <span className={`input-group-text remove-right-radius ${!isEditable && customerDetail.email4 ? 'click-wrapper ' : ''}`}>
                                                <Icon icon="email" className={`text-muted fa-fw ${!isEditable && customerDetail.email4 ? 'customer-detail-icon' : ''}`} />
                                            </span>
                                            <FloatingLabel controlId="email4" label={cstScrLables.EMAIL_4}>
                                                <Form.Control
                                                    type="email"
                                                    placeholder=" "
                                                    name="email4"
                                                    value={customerDetail.email4 ?? ""}
                                                    onChange={(event) => onEntityFieldChange('email4', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    tabIndex={322}
                                                    maxLength={150}
                                                    isInvalid={formValidation['email4']?.isValid == false}
                                                />
                                                {formValidation['email4']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['email4']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                            {renderCopyButton(customerDetail.email4)}
                                            {/*<div className="click-overlay" ></div>*/}
                                        </div>
                                    </Column>
                                </Row>
                                )}
                                {/* Email 5 */}
                                {(
                                <Row>
                                    <Column lg={12} md={12}
                                        className={formValidation['email5']?.isValid == false ? 'feedback-row' : ''}>
                                        <div className="input-group has-validation mb-3" onClick={() => handleEmailClick(customerDetail.email5 ?? "")}>
                                            <span className={`input-group-text remove-right-radius ${!isEditable && customerDetail.email5 ? 'click-wrapper ' : ''}`}>
                                                <Icon icon="email" className={`text-muted fa-fw ${!isEditable && customerDetail.email5 ? 'customer-detail-icon' : ''}`} />
                                            </span>
                                            <FloatingLabel controlId="email5" label={cstScrLables.EMAIL_5}>
                                                <Form.Control
                                                    type="email"
                                                    placeholder=" "
                                                    name="email5"
                                                    value={customerDetail.email5 ?? ""}
                                                    onChange={(event) => onEntityFieldChange('email5', event.currentTarget.value)}
                                                    disabled={!isEditable}
                                                    tabIndex={323}
                                                    maxLength={150}
                                                    isInvalid={formValidation['email5']?.isValid == false}
                                                />
                                                {formValidation['email5']?.isValid == false && (
                                                    <Form.Control.Feedback type="invalid">
                                                        {formValidation['email5']?.warningText}
                                                    </Form.Control.Feedback>
                                                )}
                                            </FloatingLabel>
                                            {renderCopyButton(customerDetail.email5)}
                                            {/*<div className="click-overlay" ></div>*/}
                                        </div>
                                    </Column>
                                </Row>
                                )}
                                <Overlay target={copyOverlayTarget} show={showCopyTooltip} placement="top">
                                    {(props) => (
                                        <Tooltip {...props}>
                                            Copied!
                                        </Tooltip>
                                    )}
                                </Overlay>
                            </Panel>
                        </div>
                    </Column>

                    <Row className="dv-cst-actions sticky-bottom bg-white p-2 shadow-lg border-top">
                        <Column lg={3} md={3}>
                            <Button
                                variant="outline-primary"
                                onClick={() => CancelEdit()}
                                tabIndex={325}
                                id="btnCancel"
                                disabled={!isEditable}
                                style={{ minWidth: "90px" }}
                                className="me-2"
                            >
                                {label.CANCEL.toLocaleUpperCase()}
                            </Button>

                            {!isCreatingNewCustomer && (
                                <Button
                                    variant="outline-danger"
                                    onClick={() => deleteCustomer()}
                                    tabIndex={330}
                                    id="btnDelete"
                                    style={{ minWidth: "90px" }}
                                    className="ms-2"
                                    disabled={!canUserDeleteCustomer}
                                >
                                    {label.DELETE.toLocaleUpperCase()}
                                </Button>
                            )}
                        </Column>

                        <Column lg={6} md={6}></Column>

                        <Column lg={3} md={3} className="text-end">
                            <Button
                                variant="outline-primary"
                                onClick={() => EditCustomer()}
                                tabIndex={335}
                                id="btnEdit"
                                disabled={isEditable || !canUserEditCustomer}
                                className="me-2 action-btn-base"
                                onMouseLeave={(e) => {
                                    firstNameRef.current.focus();
                                    e.preventDefault();
                                }}
                            >
                                {label.EDIT.toLocaleUpperCase()}
                            </Button>

                            <Button
                                //variant="success"
                                onClick={() => SaveCustomer()}
                                tabIndex={340}
                                id="btnAddCustomer"
                                disabled={!isEditable}
                                className='btn btn-primary mr-2 action-btn-base'
                                onKeyDown={(e) => {
                                    if (e.key == "Tab" && !e.shiftKey) {
                                        firstNameRef.current.focus();
                                        e.preventDefault();
                                    }
                                }}
                            >
                                {label.SAVE.toLocaleUpperCase()}
                            </Button>
                        </Column>
                    </Row>

                </Row>
            </Container>

        </>
    );
};

export default CustomerDetail;